/*
  Окно и итог «Сверить все» - макет «2-сверить-все-А», выбран владельцем
  19.10.2026.

  Окно говорит прямо, что делает кнопка: страницы будут подтверждены без
  сверки с картинкой, паспорта и даты лягут так, как их прочитала программа.
  Здесь же - какие страницы останутся на сверке и почему, и отдельной строкой
  те подтверждаемые, где программа сама просила что-то проверить: решение
  нажать принимает человек, зная о них.

  Итог остаётся над сверкой списком оставшихся страниц с переходом к каждой.
  Страница, которую человек потом сверил сам, из списка уходит.
*/

import { plural } from '../../api/format.js'
import { Confirm, Notice } from '../Common.jsx'
import Modal from '../Modal.jsx'

// Винительный падеж - «подтвердить 1 страницу», именительный - «1 страница».
const pages = (count) => plural(count, 'страницу', 'страницы', 'страниц')
const pagesNamed = (count) => plural(count, 'страница', 'страницы', 'страниц')
const single = (count) => count % 10 === 1 && count % 100 !== 11
const confirmedText = (count) => `${single(count) ? 'Подтверждена' : 'Подтверждено'} ${pagesNamed(count)}.`
const staying = (count) => plural(count, 'страница останется', 'страницы останутся', 'страниц останутся')

const leftText = (left) => left.map((item) => `стр. ${item.number} - ${item.reason}`).join(', ')
// Пояснение программы бывает в несколько строк - в окне оно идёт одной.
const askedText = (asked) =>
  asked.map((item) => `стр. ${item.number} - ${item.note.split('\n').join(' ')}`).join('; ')

export function ConfirmAllDialog({ bulk }) {
  const { plan, busy, error, confirm, cancel } = bulk
  if (!plan) return null
  const count = plan.confirmed.length
  if (count === 0) {
    return (
      <Modal title="Подтверждать нечего" onClose={cancel}>
        <div className="modal__text">
          Все ждущие страницы остаются на сверке: {leftText(plan.left)}. Их нужно сверить с картинкой
          по одной.
        </div>
        <div className="row row--tight">
          <button type="button" className="button" onClick={cancel}>
            Закрыть
          </button>
        </div>
      </Modal>
    )
  }
  return (
    <Confirm
      title="Подтвердить страницы без сверки?"
      action={`Подтвердить ${pages(count)}`}
      onConfirm={confirm}
      onCancel={cancel}
      busy={busy}
      error={error}
    >
      <div className="stack">
        <p>
          Подтвердить {pages(count)} без сверки с картинкой? Паспорта и даты будут записаны так, как их
          прочитала программа.
        </p>
        {plan.left.length ? (
          <p>
            {staying(plan.left.length)} на сверке: {leftText(plan.left)}.
          </p>
        ) : null}
        {plan.asked.length ? (
          <Notice kind="warn">
            Среди подтверждаемых - {pagesNamed(plan.asked.length)}, где программа сама просила проверить:{' '}
            {askedText(plan.asked)}. Они тоже будут подтверждены.
          </Notice>
        ) : null}
      </div>
    </Confirm>
  )
}

export function ConfirmAllResult({ result, waiting, onGo }) {
  if (!result) return null
  const left = result.left.filter((item) => waiting.has(item.number))
  const done = confirmedText(result.confirmed.length)
  return (
    <Notice kind="ok">
      <div className="notice__what">
        {left.length ? `${done} Осталось на сверке ${left.length}:` : `${done} На сверке ничего не осталось.`}
      </div>
      {left.length ? (
        <ul className="scan__left">
          {left.map((item) => (
            <li key={item.number} className="scan__left-item">
              <span className="scan__left-what">
                стр. {item.number} - {item.reason}
              </span>
              <button type="button" className="button button--quiet" onClick={() => onGo(item.number)}>
                Перейти к странице {item.number}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </Notice>
  )
}
